import { PreactRenderer, Shark, SwimWay } from "shark-mvc";
import { NousCore } from "nouscore-js-api";

import User from "./models/User";

import loginView from "./views/login/loginView";
import projectListView from "./views/project/projectListView";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.min.css";

import "./css/custom.css";
import passwordResetView from "./views/password-recovery/passwordResetView";

const startUp = () => {
	const apiURL = process.env.API_URL;
	const cdnURL = process.env.CDN_URL;

	NousCore.api.settings.commonEndPointBase = apiURL + "/";

	// Dovrebbe far parte dei parametri di init
	Shark.traceLevel = Shark.TRACE_INFO;

	Shark.init({
		enableMainStoreAutoRender: true,
		enableSmartModelSetUpdatesView: true,
		routingMethod: "url",
		templateRenderer: new PreactRenderer(),
	});

	const router = new SwimWay(Shark.settings.routingMethod);

	Shark.set({
		apiURL,
		appBuildDate: __BUILD_DATE__,
		appVersion: __VERSION__,
		cdnURL,
		formatDateISO: "YYYY-MM-DD",
		isTestEnv: process.env.SYSTEM_ENV === "staging",
		onLine: true,
		router,
		workOfflineMode: false,
	});


	const urlParams = new URLSearchParams(document.location.search);

	if (urlParams.has("k")) {
		const currUser = new User();
		const tempKey = urlParams.get("k");
		const guid = urlParams.get("g");

		currUser.set({
			guid,
			tempKey,
		});
		
		Shark.set({
			confirmSent: false,
			currUser,
			tempKey,
			__tempKeyIsValid: tempKey !== null,
		});

		Shark.openPage(passwordResetView, {urlSearchParams: null});
	}
	else {
		if (localStorage.getItem("preserveLogin") === "true") {
			NousCore.api.validateSession()
			.then(response => {
				if (response.sessionIsValid) {
					NousCore.api.getSessionUser()
					.then(response => {
						if (response.userData) {
							const loggedUser = Shark.getInstance(User, response.userData);
							// Dave: SwimWay deve darmi la reuestedView come Route, anzi un metodo per la requestedRoute che tenga conto della query e dell'hash
							const requestedView = Shark.$store.router.getRequestedViewFromLocation();
							const urlSearchParams = new URLSearchParams(document.location.search);
							Shark.set({loggedUser});

							if (requestedView === "") {
								Shark.openPage(projectListView, {urlSearchParams: null});
							}
							else {
								Shark.openPage(requestedView, { urlSearchParams: urlSearchParams.toString() });
							}
						}
						else {
							Shark.openPage(loginView);
						}
					});
				}
				else {
					Shark.openPage(loginView);
				}
			});
		}
		else {
			Shark.openPage(loginView);
		}
	}

};

startUp();
